export default __webpack_public_path__ + "static/media/logo06.af4b6d45.svg";